import type { EndClient } from '@lensora/shared'
import { useQuery } from '@tanstack/react-query'

import { api } from '@/lib/api'

/**
 * List of the tenant's end clients. Shared by the Clients page and any
 * feature that needs to know whether this is a multi-client agency tenant
 * (e.g. MCP key restriction — see use-mcp-keys.ts).
 */
export function useClients(enabled = true) {
  return useQuery({
    queryKey: ['clients'],
    queryFn: () => api.get<EndClient[]>('/api/admin/clients'),
    enabled,
  })
}
